import types from '@/store/types/BandejaComun'
import Vue from 'vue';

const state = {
  datosTramitesSolicitadosNet:[],
  datosPromocionesNet:[],
}

const getters = {
  [types.getters.GetDatosTramitesSolicitadosNet]:(state) => {
    return state.datosTramitesSolicitadosNet;
  },
  [types.getters.GetDatosPromocionesNet]:(state) => {
    return state.datosPromocionesNet;
  }
}

const mutations = {
  [types.mutations.SetDatosTramitesSolicitadosNet]:(state, lst) => {
    state.datosTramitesSolicitadosNet = lst;
  },

  [types.mutations.SetDatosPromocionesNet]:(state, lst) => {
    state.datosPromocionesNet = lst;
  },
}
const actions = {

  [types.actions.ObtenerTramitesSolicitudesNet]:({commit},obj)=>{
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.get(`pajel/solicitud/eviadasNet/${obj.codTramite}/${obj.personaId}`).then(r => {
          commit(types.mutations.SetDatosTramitesSolicitadosNet,r.data)
            resolve(r);
          });
    })
  },
  [types.actions.ObtenerPromocionesNet]:({commit},obj)=>{
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.get(`pajel/promocion_empresarial/promocionesEmpresarialesNet/${obj.codTramite}/${obj.personaId}/${obj.soloVigentes}`).then(r => {
          commit(types.mutations.SetDatosPromocionesNet,r.data)
            resolve(r);
          });
    })
  },
}
export default {
  state,
  actions,
  getters,
  mutations
}
